import { Card, CardHeader } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import React, { useEffect } from "react";
import useMarketplacesFilter from "../../../components/FilterMarketplacesProvider/useFilterMarketplaces";
import { useHideFakeOrders } from "../../../components/HideFakeOrdersProvider";
import { useStatusGroup } from "../StatusGroupProvider";
import Filter from "./Filter";
import useLoading from "./hooks/useLoading";
import Table from "./Table";
import { SourceOrdersFC } from "./types";

const SourceOrders: SourceOrdersFC = () => {
    const { status: hideFakeOrders } = useHideFakeOrders();
    const { gridTitle } = useStatusGroup();
    const loading = useLoading(hideFakeOrders);
    const {
        isLoading: filteringMarketplacesloading,
        active: filteringMarketplaces,
    } = useMarketplacesFilter();
    useEffect(() => {
        loading();
    }, [hideFakeOrders, filteringMarketplacesloading, filteringMarketplaces]);
    return (
        <Card
            component={Paper}
            sx={{
                overflow: "visible",
            }}
        >
            <CardHeader title={gridTitle}></CardHeader>
            <Divider />
            <Filter loading={loading} />
            <Divider />
            <Table />
        </Card>
    );
};

export default SourceOrders;
